import React/*, { Component }*/ from "react";
import ChatMessage from "./ChatMessage.js";
class MsgQueue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      isOpened: props.isOpened,
      chatId: props.chatId,
      firstLoad: true,
      list: new Object(),
      lastMsgId: 0,
      loading: false,
      intervalId: null,
      needScrollBottom: false,
      check_read_ids: [],
    };
    this.msgQueueRef = React.createRef();
  }
  pinMessage = (messageId, is_pinned) => {
    this.state.list[messageId].is_pinned = is_pinned;
  };
  deleteMessage = (messageId) => {
    delete this.state.list[messageId];
  };
  static getDerivedStateFromProps(nextProps/*, prevProps*/) {
    if (nextProps.needReload) {
      return {
        chatId: nextProps.chatId,
        isOpened: nextProps.isOpened,
        list: new Object(),
        lastMsgId: 0,
        isLoaded: false,
        check_read_ids: [],
      };
    } else {
      return {
        chatId: nextProps.chatId,
        isOpened: nextProps.isOpened,
      };
    }
  }
  scrollToBottom = () =>
    (this.msgQueueRef.current.scrollTop =
      this.msgQueueRef.current.scrollHeight);

  componentDidUpdate() {
    this.state.loading = false;
    if (this.state.needScrollBottom) {
      this.state.needScrollBottom = false;
      this.scrollToBottom();
    }
  }

  componentDidMount() {
    //	this.loadLastMessages();
    this.state.intervalId = setInterval(() => {
      this.loadLastMessages();
    }, 500);
  }
  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }
  loadLastMessages() {
    //console.log(this.state);

    if (this.state.isOpened && !this.state.loading) {
      this.state.loading = true;
      fetch(this.props.mentorChatApiRoot + "/message/list", {
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("mentor_chat_token"),
          chat_id: this.state.chatId,
          last_msg_id: parseInt(this.state.lastMsgId, 10),
          check_read: this.state.check_read_ids,
        }),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            let readed = false;
            for (let id in result.check_read) {
              let int_id = parseInt(id, 10);
              this.state.list[int_id].readed = result.check_read[int_id];
              this.state.check_read_ids = this.state.check_read_ids.filter(
                (val) => val !== int_id
              );
              readed = true;
            }
            if (readed) {
              this.setState({ list: this.state.list });
            }
            let deleted = false;
            result.check_delete.forEach((deleted_id) => {
              if (!!this.state.list[deleted_id]) {
                deleted = true;
                delete this.state.list[deleted_id];
              }
            });
            if (deleted) {
              this.setState({ list: this.state.list });
            }
            let list = this.state.list;
            if (Object.keys(result.list).length > 0) {
              for (let key in result.list) {
                let int_key = parseInt(key, 10);
                if (result.list[int_key].readed === null) {
                  if (this.state.check_read_ids.indexOf(int_key) === -1) {
                    this.state.check_read_ids.push(int_key);
                  }
                }
                list[int_key] = result.list[int_key];
              }
              this.setState({
                isLoaded: true,
                list: list,
                isOpened: this.props.isOpened,
                lastMsgId: result.last_msg_id,
                needScrollBottom: true,
              });
            } else {
              this.setState({ isLoaded: true });
            }
          },
          // Примечание: важно обрабатывать ошибки именно здесь, а не в блоке catch(),
          // чтобы не перехватывать исключения из ошибок в самих компонентах.
          (error) => {
            console.log(error);
            this.setState({
              isLoaded: true,
              error: error,
            });
          }
        );
    }
  }
  render() {
    // eslint-disable-next-line no-unused-vars
    const { error, isLoaded, isOpened, list } = this.state;
    if (error) {
      this.state.error = false;
      return (
        <div className="MsgQueue" ref={this.msgQueueRef}>
          Ошибка: {error.message}
        </div>
      );
    } else if (!isLoaded) {
      return (
        <div className="MsgQueue" ref={this.msgQueueRef}>
          Загрузка...
        </div>
      );
    } else {
      return (
        <div className="MsgQueue" ref={this.msgQueueRef}>
          {Object.keys(list)
            .sort((a, b) => list[a].ts - list[b].ts)
            .map((id) => (
              <ChatMessage
                key={id}
                msg={list[id]}
                pinMessage={this.pinMessage}
                deleteMessage={this.deleteMessage}
                mentorChatApiRoot={this.props.mentorChatApiRoot}
              />
            ))}
        </div>
      );
    }
  }
}
//<span className="checkTwo">🗸</span>
export default MsgQueue;
